module.exports = __webpack_public_path__ + "img/bulb-icon.31037189.svg";